module.exports = __webpack_public_path__ + "img/KG.05368bdd.svg";